import { render, staticRenderFns } from "./VisaCard.vue?vue&type=template&id=b064db94&scoped=true&"
import script from "./VisaCard.vue?vue&type=script&lang=js&"
export * from "./VisaCard.vue?vue&type=script&lang=js&"
import style0 from "./VisaCard.vue?vue&type=style&index=0&id=b064db94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b064db94",
  null
  
)

export default component.exports